// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"f91d7cae6f3409e05767","731":"c43583528080fd434f55","843":"4d22e4d87d98fa226c97","883":"2e1baaa764f47093fd7f"}[chunkId] + ".js";
};